import { useSelector } from "react-redux";
import { type RootStateI } from "../index";
import { type POSAPricesJavascriptDTO } from "@tootsweet/model/lottery/POSAPrices";
import { type EventConfig } from "kadow-jetpack-model";
import { POSATypeJavascriptDTO } from "@tootsweet/model/lottery/POSAType";

export const SET_CONFIGURATION = "SET_CONFIGURATION";
export const SET_POSA_TYPES = "SET_POSA_TYPES";
export const SET_POSA_PRICES = "SET_POSA_PRICES";
export const SET_EVENTS_TYPE = "SET_EVENTS_TYPE";

export const setEvents = (events: EventConfig[]) => {
  return {
    type: SET_EVENTS_TYPE,
    events
  };
};

export const setPOSATypes = (posaTypes: POSATypeJavascriptDTO[]) => {
  return {
    type: SET_POSA_TYPES,
    posaTypes
  };
};

export const setPOSAPrices = (posaPrices: POSAPricesJavascriptDTO[]) => {
  return {
    type: SET_POSA_PRICES,
    posaPrices
  };
};

export const useEventsSelector = () => {
  return useSelector<RootStateI, EventConfig[]>((s) => s.wheel.events);
};

export const usePOSATypesSelector = () => {
  return useSelector<RootStateI, POSATypeJavascriptDTO[]>(
    (s) => s.wheel.posaTypes
  );
};

export const usePOSAPricesSelector = () => {
  return useSelector<RootStateI, POSAPricesJavascriptDTO[]>(
    (s) => s.wheel.posaPrices
  );
};

export const usePOSAOrderIsRecomputingSelector = () => {
  return useSelector<RootStateI, boolean>((s) => s.saas.posaOrderIsRecomputing);
};

export const useAddingPOSAToBasketIdsSelector = () => {
  return useSelector<RootStateI, string[]>(
    (s) => s.saas.addingPOSAToBasketIds
  );
};
